import React from 'react';
import PropTypes from 'prop-types';
import {Route} from 'react-router-dom';

import {connect} from '@stubhub/react-store-provider';

import controller from './controller';
import getSearchParams from './getSearchParams';

@connect(controller)
class QueryRoute extends React.Component {
  UNSAFE_componentWillMount() {
    const {updateQuery, replaceQuery} = this.props;
    const {router, logger} = this.context;
    const {route, history} = router;
    const {location} = route;
    updateQuery({
      query: getSearchParams(location.search),
    });
    if (history) {
      history.listen((location, action) => {
        logger.info(`The current URL is ${location.pathname}${location.search}${location.hash}`, location);
        logger.info(`The last navigation action was ${action}`);
        replaceQuery({
          query: getSearchParams(location.search),
        });
      });
    }
  }

  render() {
    const {children} = this.props;

    return <Route {...this.props}>{children}</Route>;
  }
}

QueryRoute.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  updateQuery: PropTypes.func,
  replaceQuery: PropTypes.func,
};

QueryRoute.contextTypes = {
  logger: PropTypes.object,
  router: PropTypes.object,
};

export default QueryRoute;
